import React from "react";
import { Select } from "antd";
import styles from './Styles.module.css'

const { Option } = Select;

export default function AnswereSortFilters({ value, onChangeFunc, options }) {
  const onChangeSelectedOption = (value) => {
    const selectedOption = options.find((option) => option.value === value);
    onChangeFunc(selectedOption);
  };

  return (
    <Select
      className={styles.selectCss}
      onChange={onChangeSelectedOption}
      placeholder="Select Sort"
      value={value?.value}
      style={{ width: "100%" ,height:"40px"}}
    >
      {options.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
}
